import buildLocalizeFn from '../../../_lib/buildLocalizeFn/index';

function ordinalNumber(dirtyNumber, dirtyOptions) {
  const number = Number(dirtyNumber);

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'ኛ';
      case 2:
        return number + 'ኛ';
      case 3:
        return number + 'ኛ';
    }
  }
  return number + 'ኛ';
}

const eraValues = {
  narrow: ['ቅልክ', 'ዓም'],
  abbreviated: ['ቅልክ', 'ዓም'],
  wide: ['ቅድመ ልደተ ክርስቶስ', 'ዓመተ ምህረት'],
};

const quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1ኛ ሩብ', '2ኛ ሩብ', '3ኛ ሩብ', '4ኛ ሩብ'],
};

const monthValues = {
  narrow: ['ጃ', 'ፌ', 'ማ', 'ኤ', 'ሜ', 'ጁን', 'ጁላ', 'ኦገ', 'ሴ', 'ኦክ', 'ኖ', 'ዲ'],
  abbreviated: [
    'ጃንወ',
    'ፌብሩ',
    'ማርች',
    'ኤፕሪ',
    'ሜይ',
    'ጁን',
    'ጁላይ',
    'ኦገስ',
    'ሴፕቴ',
    'ኦክቶ',
    'ኖቬም',
    'ዲሴም',
  ],
  wide: [
    'ጃንወሪ',
    'ፌብሩወሪ',
    'ማርች',
    'ኤፕሪል',
    'ሜይ',
    'ጁን',
    'ሁላይ',
    'ኦገስት',
    'ሴፕቴምበር',
    'ኦክቶበር',
    'ኖቬምበር',
    'ዲሴምበር',
  ],
};

const dayValues = {
  narrow: ['እ', 'ሰ', 'ማ', 'ረ', 'ሐ', 'ዓ', 'ቅ'],
  short: ['እሁ', 'ሰኞ', 'ማክ', 'ረቡ', 'ሐሙ', 'ዓር', 'ቅዳ'],
  abbreviated: ['እሁ', 'ሰ', 'ማክ', 'ረቡ', 'ሐሙ', 'ዓር', 'ቅዳሜ'],
  wide: ['እሁድ', 'ሰኞ', 'ማክሰኞ', 'ረቡዕ', 'ሐሙስ', 'ዓርብ', 'ቅዳሜ'],
};

const dayPeriodValues = {
  narrow: {
    am: 'ጥዋት',
    pm: 'ከሰዓት',
    midnight: 'እኩለ ሌሊት',
    noon: 'ቀትር',
    morning: 'ጥዋት',
    afternoon: 'ከሰዓት በኋላ',
    evening: 'ምሽት',
    night: 'ሌሊት',
  },
  abbreviated: {
    am: 'ጥዋት',
    pm: 'ከሰዓት በኋላ',
    midnight: 'እኩለ ሌሊት',
    noon: 'ቀትር',
    morning: 'ጥዋት',
    afternoon: 'ከሰዓት በኋላ',
    evening: 'ምሽት',
    night: 'ሌሊት',
  },
  wide: {
    am: 'ጥዋት',
    pm: 'ከሰዓት',
    midnight: 'እኩለ ሌሊት',
    noon: 'ቀትር',
    morning: 'ጥዋት',
    afternoon: 'ከሰዓት በኋላ',
    evening: 'ምሽት',
    night: 'ሌሊት',
  },
};

const localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide',
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    },
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
  }),
};

export default localize;
